@if (personalHierarchy$ | async; as personalHierarchy) {
    <div>
        <adapt-display-navigation-node class="heading-node"
                                       [node]="personalHierarchy"></adapt-display-navigation-node>
        <ul>
            @for (childNode of personalHierarchy?.children || []; track childNode) {
                <li>
                    <adapt-display-link-hierarchy [hierarchy]="childNode"></adapt-display-link-hierarchy>
                </li>
            }
        </ul>
    </div>
}
